/**
 * attachmentsIds: the upload ids attached to the *current* request — the source of truth.
 * history.data: attachments of the user's *previous* requests, carrying the display metadata
 * (original_file_name, mime_type). A freshly uploaded attachment is not in there yet, so we
 * drive the list from attachmentsIds and only enrich from history when a match exists.
 */
export const getRequestAttachmentsFromHistoryWithoutDuplication = (history, attachmentsIds) => {
  const metadataById = new Map();

  if (history && Array.isArray(history.data)) {
    history.data.forEach(attachment => {
      const id = parseInt(attachment.id, 10);
      if (!metadataById.has(id)) {
        metadataById.set(id, attachment);
      }
    });
  }

  const attachmentSeen = new Set();
  const attachments = [];

  (attachmentsIds || []).forEach(rawId => {
    const id = parseInt(rawId, 10);

    if (Number.isNaN(id) || attachmentSeen.has(id)) {
      return;
    }

    attachmentSeen.add(id);
    // ponytail: id-only fallback renders through the download endpoint; the viewer
    // handles the missing mime_type. Drop it once an endpoint returns the current
    // request's attachments with metadata.
    attachments.push(metadataById.get(id) || { id });
  });

  return attachments;
};

export const prepareRequestTypeLabel = TYPE => {
  if (TYPE === 'NOTICE') {
    return 'إصدار إشعار';
  }
  if (TYPE === 'VISA') {
    return 'إصدار تأشيرة';
  }
  if (TYPE === 'DL_TRANSFER') {
    return 'نقل خدمات';
  }
  return '';
};
